import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayAdjustmentHistoryList extends Layout {
    labelHeader: Label;
    sourceDrsDeductHist: DataSource;
    tablePayAdjustmentHistory: Table;
}
